import { QueryFunctionContext } from 'react-query'

import { endPoints } from '@/configs/endPoints'
import { IComponenteDeCreditoParams, IComponenteDeCreditoResponse } from '@/interfaces/componente-de-credito'
import { API_COBRANCAS } from '@/utils/cobrancas-fetcher'

export async function submeterPedido(
    ctx: QueryFunctionContext<
        [
          string,
          {
            params: IComponenteDeCreditoParams
          }
        ]
      >
): Promise<IComponenteDeCreditoResponse> {
  const [, { params }] = ctx.queryKey
  const response = await API_COBRANCAS.post<IComponenteDeCreditoResponse>(
    endPoints.componenteDeCredito,{
        ...params
    }
  )

  return response
}